import { render, staticRenderFns } from "./assignment.vue?vue&type=template&id=c20535a0&scoped=true"
import script from "./assignment.vue?vue&type=script&lang=js"
export * from "./assignment.vue?vue&type=script&lang=js"
import style0 from "./assignment.vue?vue&type=style&index=0&id=c20535a0&prod&lang=scss"
import style1 from "./assignment.vue?vue&type=style&index=1&id=c20535a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20535a0",
  null
  
)

export default component.exports